import { createContext, type RefObject, useContext } from 'react';

const OUTSIDE_ANY_DOCK: RefObject<HTMLElement | null> = { current: null };

/** The element of the tool options dock that renders its children. */
export const ToolOptionsDockContext =
    createContext<RefObject<HTMLElement | null>>(OUTSIDE_ANY_DOCK);

/**
 * A ref to the tool options dock that holds the caller, so a panel that a
 * control in the dock opens can line up with the dock rather than with the
 * control. Its `current` is null outside a dock.
 */
export function useToolOptionsDockRef(): RefObject<HTMLElement | null> {
    return useContext(ToolOptionsDockContext);
}
